import React, { FC, useState } from 'react'
import MuiPhoneNumber, { MuiPhoneNumberProps } from 'material-ui-phone-number'
import { makeStyles, createStyles } from '@mui/styles'
import { Theme, FormControl, FormHelperText } from '@mui/material'
import parsePhoneNumber, { CountryCode } from 'libphonenumber-js'
import clsx from 'clsx'
import { Controller } from 'react-hook-form'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiPhoneNumber-flagButton': {
        width: 'min-content',
      },
    },
    labelRoot: {
      fontSize: 19,
      '&$labelFocused': {
        color: 'purple',
      },
    },
    labelFocused: {},
    valid: {
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
      },
    },
    notValid: {
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
    },
  }),
)

export interface PhoneNumberInputProps
  extends Omit<MuiPhoneNumberProps, 'onChange'> {
  value?: string
  label: string
  onChange?: (phoneNumber?: string) => void
  form: any
  name?: string
  mb?: number
  slot?: any
  country?: string
}

interface Value {
  countryCode: CountryCode
  dialCode: string
  name: string
}

const InputPhoneNumber: FC<PhoneNumberInputProps> = ({
  value,
  label,
  onChange,
  form,
  name,
  mb,
  country = 'tr',
  ...rest
}: any) => {
  const [isValid, setIsValid] = useState(true)
  const classes = useStyles()

  return (
    <Controller
      name={name}
      control={form.control}
      render={({
        field: { onChange, value, ...rest },
        fieldState: { error, ...state },
      }: any) => {
        const hasError = !!error
        return (
          <FormControl fullWidth sx={{ mb }} error={hasError}>
            <MuiPhoneNumber
              error={hasError}
              size="small"
              sx={{ mb: mb || 1, width: '100%' }}
              className={clsx(classes.root, {
                [classes.valid]: isValid,
                [classes.notValid]: error || !isValid,
              })}
              style={{ direction: 'ltr' }}
              {...rest}
              defaultCountry={country}
              value={value}
              label={label}
              variant="outlined"
              onChange={(number: string, value: Value) => {
                const { countryCode } = value
                const phoneNumber = parsePhoneNumber(number, countryCode)

                if (phoneNumber && phoneNumber.isValid()) {
                  setIsValid(true)
                  onChange(number)
                } else {
                  setIsValid(false)
                  onChange('')
                }
              }}
            />
            {hasError && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )
      }}
    />
  )
}

export default InputPhoneNumber
